const enumKeys = <O extends object, K extends keyof O = keyof O>(obj: O, isValue = false): K[] =>
  Object.keys(obj).filter(k => (isValue ? !Number.isNaN(+k) : Number.isNaN(+k))) as K[];

export default enumKeys;
